"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRICES_CURRENT_PRICE = exports.PRICES_CROSSED_CATALOG_PRICE = exports.PRICES_CATALOG_PRICE = exports.PRICES = exports.BRAND_PARTNER_ID = void 0;
const PRICES = exports.PRICES = 'prices';
const PRICES_CURRENT_PRICE = exports.PRICES_CURRENT_PRICE = 'prices-current-price';
const PRICES_CATALOG_PRICE = exports.PRICES_CATALOG_PRICE = 'prices-catalog-price';
const PRICES_CROSSED_CATALOG_PRICE = exports.PRICES_CROSSED_CATALOG_PRICE = 'prices-crossed-catalog-price';

/** Consultant or Brand Partner */
const BRAND_PARTNER_ID = exports.BRAND_PARTNER_ID = 1;
